/* FBD Outlet — site behaviour. ES5-compatible (no arrow functions, optional chaining, etc.)
   Works in the static preview (mock cart) and in Shopify (AJAX cart) — the theme sets data-shopify="1" on <body>. */
(function () {
  'use strict';
  var doc = document;
  var root = doc.documentElement;
  var body = doc.body;
  var isShopify = body.getAttribute('data-shopify') === '1';
  root.className += ' js';

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn, false); }
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    return '$' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function storage(key, val) {
    try {
      if (val === undefined) return window.localStorage.getItem(key);
      if (val === null) window.localStorage.removeItem(key); else window.localStorage.setItem(key, val);
    } catch (e) { return null; }
  }



  /* ---------- Theme toggle ---------- */
  (function theme() {
    var btns = $$('[data-theme-toggle]');
    if (!btns.length) return;
    function current() {
      var explicit = root.getAttribute('data-theme');
      if (explicit) return explicit;
      return (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) ? 'dark' : 'light';
    }
    function label(mode) {
      for (var i = 0; i < btns.length; i++) {
        btns[i].setAttribute('aria-label', mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
      }
    }
    function apply(next) {
      root.setAttribute('data-theme', next);
      storage('fbd-theme', next);
      label(next);
    }
    for (var i = 0; i < btns.length; i++) {
      on(btns[i], 'click', function () { apply(current() === 'dark' ? 'light' : 'dark'); });
    }
    /* the markup says "Switch to dark mode"; a page that opens dark must say the opposite */
    label(current());
    var mm = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
    if (mm && mm.addListener) mm.addListener(function () { if (!root.getAttribute('data-theme')) label(current()); });
  })();

  /* ---------- Header scroll state ---------- */
  (function header() {
    var h = $('[data-header]');
    if (!h) return;
    var ticking = false;
    function update() { h.className = h.className.replace(' is-scrolled', '') + (window.pageYOffset > 8 ? ' is-scrolled' : ''); ticking = false; }
    on(window, 'scroll', function () { if (!ticking) { ticking = true; (window.requestAnimationFrame || setTimeout)(update); } });
    update();
  })();

  /* ---------- Mobile nav ---------- */
  (function mobileNav() {
    var nav = $('[data-mobile-nav]');
    var open = $('[data-menu-open]');
    var close = $('[data-menu-close]');
    if (!nav || !open) return;
    function show() { nav.hidden = false; body.className += ' no-scroll'; open.setAttribute('aria-expanded', 'true'); if (close) close.focus(); }
    function hide() { nav.hidden = true; body.className = body.className.replace(' no-scroll', ''); open.setAttribute('aria-expanded', 'false'); open.focus(); }
    on(open, 'click', show);
    on(close, 'click', hide);
    $$('a', nav).forEach(function (a) { on(a, 'click', hide); });
    on(doc, 'keydown', function (e) { if (e.key === 'Escape' && !nav.hidden) hide(); });
  })();

  /* ---------- Hero form switch: buttons, ghost word, product row and CTA ---------- */


  /* ---------- Formulas timeline ---------- */
  (function timeline() {
    var tl = $('[data-timeline]');
    if (!tl) return;
    var stops = $$('[data-stop]', tl);
    var panels = $$('[data-panel]', tl);
    function select(id, focus) {
      stops.forEach(function (s) {
        var active = s.getAttribute('data-stop') === id;
        s.setAttribute('aria-selected', active ? 'true' : 'false');
        s.setAttribute('tabindex', active ? '0' : '-1');
        if (active && focus) s.focus();
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== id; });
    }
    stops.forEach(function (s, i) {
      on(s, 'click', function () { select(s.getAttribute('data-stop'), false); });
      on(s, 'keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = stops[(i + 1) % stops.length];
        if (e.key === 'ArrowLeft') n = stops[(i - 1 + stops.length) % stops.length];
        if (e.key === 'Home') n = stops[0];
        if (e.key === 'End') n = stops[stops.length - 1];
        if (n) { e.preventDefault(); select(n.getAttribute('data-stop'), true); }
      });
    });
    var initial = $('[data-stop][aria-selected="true"]', tl) || stops[0];
    if (initial) select(initial.getAttribute('data-stop'), false);
  })();

  /* ---------- Product gallery ---------- */
  (function gallery() {
    var g = $('[data-gallery]');
    if (!g) return;
    var mains = $$('[data-gallery-main]', g);
    var thumbs = $$('[data-gallery-thumb]', g);
    thumbs.forEach(function (t) {
      on(t, 'click', function () {
        var id = t.getAttribute('data-gallery-thumb');
        thumbs.forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
        mains.forEach(function (m) { m.hidden = m.getAttribute('data-gallery-main') !== id; });
      });
    });
  })();

  /* ---------- Quantity steppers ---------- */
  on(doc, 'click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-qty]') : null;
    if (!b) return;
    var wrap = b.parentNode;
    var input = $('input', wrap);
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += b.getAttribute('data-qty') === '+' ? 1 : -1;
    if (v < 1) v = 1;
    if (v > 99) v = 99;
    input.value = v;
    var ev; try { ev = new Event('change', { bubbles: true }); } catch (err) { ev = doc.createEvent('Event'); ev.initEvent('change', true, true); }
    input.dispatchEvent(ev);
  });

  /* ---------- Sticky add-to-cart bar (mobile) ---------- */
  (function stickyAtc() {
    var bar = $('[data-sticky-atc]');
    var anchor = $('[data-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var below = e.boundingClientRect.top < 0;
      bar.className = bar.className.replace(' is-visible', '') + (!e.isIntersecting && below ? ' is-visible' : '');
    }, { threshold: 0 });
    io.observe(anchor);
  })();

  /* ---------- Reveal on scroll ---------- */
  (function reveal() {
    var els = $$('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.className += ' is-in'; }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.className += ' is-in'; io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  })();

  /* ---------- Toast ---------- */
  var toastEl = $('[data-toast]');
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.className = toastEl.className.replace(' is-visible', '') + ' is-visible';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.className = toastEl.className.replace(' is-visible', ''); }, 2600);
  }

  /* ---------- Cart (Shopify AJAX or preview mock) ---------- */
  var Cart = (function () {
    var drawer = $('[data-cart-drawer]');
    var overlay = $('[data-cart-overlay]');
    var list = $('[data-cart-lines]');
    var empty = $('[data-cart-empty]');
    var foot = $('[data-cart-foot]');
    var totalEl = $('[data-cart-total]');
    var counts = $$('[data-cart-count]');
    var lastFocus = null;

    /* -- transport -- */
    function request(method, url, data) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open(method, url, true);
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        if (data) xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = function () {
          var json = null;
          try { json = JSON.parse(xhr.responseText); } catch (e) { json = null; }
          if (xhr.status >= 200 && xhr.status < 300) resolve(json); else reject(json || { message: 'Request failed' });
        };
        xhr.onerror = function () { reject({ message: 'Network error' }); };
        xhr.send(data ? JSON.stringify(data) : null);
      });
    }

    var mock = {
      read: function () { try { return JSON.parse(storage('fbd-cart-demo') || '{"items":[]}'); } catch (e) { return { items: [] }; } },
      write: function (c) { storage('fbd-cart-demo', JSON.stringify(c)); return normalize(c); },
      add: function (item) {
        var c = mock.read();
        var found = null;
        for (var i = 0; i < c.items.length; i++) if (c.items[i].id === item.id) found = c.items[i];
        if (found) found.quantity += item.quantity; else c.items.push(item);
        return Promise.resolve(mock.write(c));
      },
      change: function (id, qty) {
        var c = mock.read();
        c.items = c.items.filter(function (it) { if (it.id === id) { it.quantity = qty; } return it.quantity > 0; });
        return Promise.resolve(mock.write(c));
      },
      get: function () { return Promise.resolve(normalize(mock.read())); }
    };

    function normalize(c) {
      var items = (c.items || []).map(function (it) {
        return {
          id: it.id, key: it.key || it.id, title: it.product_title || it.title, variant: it.variant_title,
          quantity: it.quantity, price: it.price, line: it.line_price !== undefined ? it.line_price : it.price * it.quantity,
          image: it.image, url: it.url
        };
      });
      var total = 0, count = 0;
      items.forEach(function (it) { total += it.line; count += it.quantity; });
      return { items: items, total: c.total_price !== undefined ? c.total_price : total, count: c.item_count !== undefined ? c.item_count : count };
    }

    var api = isShopify ? {
      add: function (item) { return request('POST', '/cart/add.js', { items: [{ id: item.id, quantity: item.quantity }] }).then(api.get); },
      change: function (id, qty) { return request('POST', '/cart/change.js', { id: id, quantity: qty }).then(normalize); },
      get: function () { return request('GET', '/cart.js').then(normalize); }
    } : mock;

    /* -- render -- */
    function render(cart) {
      counts.forEach(function (c) { c.textContent = cart.count; c.setAttribute('data-count', String(cart.count)); });
      if (!list) return;
      list.innerHTML = '';
      var has = cart.items.length > 0;
      if (empty) empty.hidden = has;
      if (foot) foot.hidden = !has;
      if (totalEl) totalEl.textContent = money(cart.total);
      cart.items.forEach(function (it) {
        var li = doc.createElement('li');
        li.className = 'line';
        li.innerHTML =
          '<div class="line__img">' + (it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : '') + '</div>' +
          '<div>' +
            '<div class="line__title">' + it.title + '</div>' +
            (it.variant && it.variant !== 'Default Title' ? '<div class="small muted">' + it.variant + '</div>' : '') +
            '<div class="line__meta">' +
              '<div class="qty"><button class="qty__btn" type="button" data-qty="-" aria-label="Decrease quantity">&minus;</button>' +
              '<input class="qty__input" type="number" min="0" value="' + it.quantity + '" aria-label="Quantity" data-line-qty="' + it.key + '">' +
              '<button class="qty__btn" type="button" data-qty="+" aria-label="Increase quantity">+</button></div>' +
              '<span class="price num">' + money(it.line) + '</span>' +
            '</div>' +
            '<button class="line__remove" type="button" data-line-remove="' + it.key + '">Remove</button>' +
          '</div>';
        list.appendChild(li);
      });
    }

    function open() {
      if (!drawer) return;
      lastFocus = doc.activeElement;
      drawer.className += ' is-open';
      if (overlay) overlay.className += ' is-open';
      drawer.setAttribute('aria-hidden', 'false');
      body.className += ' no-scroll';
      var c = $('[data-cart-close]', drawer); if (c) c.focus();
    }
    function close() {
      if (!drawer) return;
      drawer.className = drawer.className.replace(' is-open', '');
      if (overlay) overlay.className = overlay.className.replace(' is-open', '');
      drawer.setAttribute('aria-hidden', 'true');
      body.className = body.className.replace(' no-scroll', '');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    on(overlay, 'click', close);
    $$('[data-cart-close]').forEach(function (b) { on(b, 'click', close); });
    $$('[data-cart-open]').forEach(function (b) { on(b, 'click', function (e) { if (drawer) { e.preventDefault(); api.get().then(render); open(); } }); });
    on(doc, 'keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.className.indexOf('is-open') > -1) close(); });

    on(doc, 'change', function (e) {
      var inp = e.target;
      if (!inp.getAttribute || !inp.getAttribute('data-line-qty')) return;
      var qty = parseInt(inp.value, 10); if (isNaN(qty) || qty < 0) qty = 0;
      api.change(inp.getAttribute('data-line-qty'), qty).then(render);
    });
    on(doc, 'click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-line-remove]') : null;
      if (!b) return;
      api.change(b.getAttribute('data-line-remove'), 0).then(render);
    });

    /* add-to-cart forms */
    $$('form[data-add-to-cart]').forEach(function (form) {
      on(form, 'submit', function (e) {
        if (!drawer) return; /* no drawer: let the form post to /cart/add normally */
        e.preventDefault();
        var btn = $('[type="submit"]', form);
        var idInput = $('[name="id"]', form);
        var qtyInput = $('[name="quantity"]', form);
        var item = {
          id: idInput ? idInput.value : form.getAttribute('data-id'),
          quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1,
          title: form.getAttribute('data-title'),
          price: parseInt(form.getAttribute('data-price'), 10) || 0,
          image: form.getAttribute('data-image')
        };
        var label = btn ? btn.innerHTML : '';
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.innerHTML = 'Adding&hellip;'; }
        api.add(item).then(function (cart) {
          render(cart);
          if (btn) {
            btn.removeAttribute('aria-disabled');
            btn.innerHTML = 'Added';
            btn.className += ' is-added';
            setTimeout(function () { btn.innerHTML = label; btn.className = btn.className.replace(' is-added', ''); }, 1400);
          }
          $$('[data-cart-count]').forEach(function (c) {
            c.className = c.className.replace(' is-bumped', '') + ' is-bumped';
            setTimeout(function () { c.className = c.className.replace(' is-bumped', ''); }, 500);
          });
          toast('Added to your cart');
          open();
        }, function (err) {
          if (btn) { btn.removeAttribute('aria-disabled'); btn.innerHTML = label; }
          toast((err && (err.description || err.message)) || 'Could not add to cart');
        });
      });
    });

    if (window.Promise) api.get().then(render, function () {});
    return { open: open, close: close, refresh: function () { if (window.Promise) api.get().then(render); } };
  })();

  /* ---------- Newsletter (preview only; Shopify uses the customer form) ---------- */
  (function newsletter() {
    var form = $('[data-newsletter-demo]');
    if (!form) return;
    on(form, 'submit', function (e) {
      e.preventDefault();
      var msg = $('[data-form-msg]', form);
      var email = $('input[type="email"]', form);
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) { if (msg) { msg.textContent = 'Please enter a valid email address.'; msg.className = 'form-msg form-msg--error'; } return; }
      if (msg) { msg.textContent = 'You are on the list. Welcome.'; msg.className = 'form-msg'; }
      email.value = '';
    });
  })();


  /* ---------- Scroll parallax for floating props ---------- */
  (function parallax() {
    var props = $$('[data-parallax]');
    if (!props.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    function frame() {
      var vh = window.innerHeight || doc.documentElement.clientHeight;
      for (var i = 0; i < props.length; i++) {
        var el = props[i];
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) continue;
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.1;
        var mid = r.top + r.height / 2 - vh / 2;
        el.style.transform = 'translate3d(0,' + (-mid * speed).toFixed(1) + 'px,0)';
      }
      ticking = false;
    }
    function onScroll() { if (!ticking) { ticking = true; (window.requestAnimationFrame || setTimeout)(frame); } }
    on(window, 'scroll', onScroll);
    on(window, 'resize', onScroll);
    frame();
  })();

  /* ---------- Marquee: duplicate the group so the loop is seamless ---------- */
  /* ---------- Marquee ----------
     Driven by JS rather than a CSS keyframe. The old version varied speed by writing
     animation-duration on every scroll frame, and each rewrite restarted the animation
     from its first keyframe, which read as a jump. Advancing the transform ourselves
     lets the speed change continuously with nothing to restart. Without JS the CSS
     keyframe in fbd.css still runs, so the belt never sits dead. */
  (function marquee() {
    var tracks = $$('[data-marquee]');
    if (!tracks.length) return;

    /* enough copies that the belt covers the viewport twice over, whatever the text */
    tracks.forEach(function (track) {
      var group = $('.marquee__group', track);
      if (!group) return;
      var one = group.offsetWidth || 0;
      var need = one > 0 ? Math.ceil((window.innerWidth * 2) / one) : 1;
      if (need < 1) need = 1;
      for (var c = 0; c < need; c++) track.appendChild(group.cloneNode(true));
      track.className += ' is-ready';
    });

    /* wantsMotion is declared further down the file, so it is still undefined here;
       ask the media query directly rather than depending on declaration order. */
    var moves = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (!moves || !('requestAnimationFrame' in window)) return;

    var belts = [];
    tracks.forEach(function (track) {
      var group = $('.marquee__group', track);
      if (!group) return;
      track.style.animation = 'none';   /* JS owns the transform from here on */
      var belt = { track: track, group: group, w: 0, x: 0, live: true, held: false };
      /* the belt is real copy: let people stop it to read it */
      on(track, 'mouseenter', function () { belt.held = true; });
      on(track, 'mouseleave', function () { belt.held = false; });
      belts.push(belt);
    });
    if (!belts.length) return;

    function measure() {
      for (var i = 0; i < belts.length; i++) {
        var w = belts[i].group.offsetWidth;
        if (w > 0) {
          /* hold the visual position when the width changes under us */
          if (belts[i].w > 0) belts[i].x = belts[i].x / belts[i].w * w;
          belts[i].w = w;
        }
      }
    }
    measure();
    on(window, 'resize', measure);
    on(window, 'load', measure);
    if (doc.fonts && doc.fonts.ready && doc.fonts.ready.then) doc.fonts.ready.then(measure);

    var BASE = 40;        /* px per second when the page is still */
    var boost = 0;        /* extra px per second the scroll has just handed it */
    var lastY = window.pageYOffset;
    var lastT = 0;
    var running = false;

    on(window, 'scroll', function () {
      var y = window.pageYOffset;
      boost += (y - lastY) * 5;
      lastY = y;
      if (boost > 1800) boost = 1800;
      if (boost < -1800) boost = -1800;
    });

    /* the loop only advances a belt that is actually on screen */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          for (var i = 0; i < belts.length; i++) {
            if (belts[i].track === en.target) belts[i].live = en.isIntersecting;
          }
          if (en.isIntersecting) start();
        });
      }, { rootMargin: '140px 0px' });
      for (var b0 = 0; b0 < belts.length; b0++) io.observe(belts[b0].track);
    }

    function tick(ts) {
      var dt = lastT ? Math.min(0.05, (ts - lastT) / 1000) : 0;
      lastT = ts;
      boost *= Math.pow(0.0016, dt);   /* bleeds away, so it eases back to resting speed */
      var v = BASE + boost;
      for (var i = 0; i < belts.length; i++) {
        var bl = belts[i];
        if (!bl.w || !bl.live || bl.held) continue;
        bl.x = (((bl.x + v * dt) % bl.w) + bl.w) % bl.w;   /* wraps in both directions */
        bl.track.style.transform = 'translate3d(' + (-bl.x).toFixed(2) + 'px,0,0)';
      }
      if (anyLive()) window.requestAnimationFrame(tick);
      else running = false;
    }
    function anyLive() {
      for (var i = 0; i < belts.length; i++) if (belts[i].live) return true;
      return false;
    }
    function start() {
      if (running) return;
      running = true; lastT = 0;
      window.requestAnimationFrame(tick);
    }
    start();
  })();

  /* ---------- Count up the heritage figures once they scroll in ---------- */
  (function counters() {
    var els = $$('[data-count-to]');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function run(el) {
      var target = parseFloat(el.getAttribute('data-count-to'));
      var suffix = el.getAttribute('data-count-suffix') || '';
      if (reduce || !('requestAnimationFrame' in window)) { el.textContent = target + suffix; return; }
      var start = null, dur = 1100;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (p < 1) window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  })();

  /* ---------- Reading progress rail ---------- */
  (function progress() {
    var bar = $('[data-progress]');
    if (!bar) return;
    var ticking = false;
    function frame() {
      var de = doc.documentElement;
      var max = de.scrollHeight - de.clientHeight;
      bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, window.pageYOffset / max) : 0).toFixed(4) + ')';
      ticking = false;
    }
    on(window, 'scroll', function () { if (!ticking) { ticking = true; (window.requestAnimationFrame || setTimeout)(frame); } });
    frame();
  })();



  /* ---------- Scroll stage: pin the hero and cycle the product slides ----------
     Enhancement only. It switches on when the browser can do it well; otherwise
     the slides stay stacked and the page reads exactly as it would without JS. */
  function buildStage() {
    var el = $('[data-stage]');

    /* In Shopify each section is its own sibling <div id="shopify-section-...">, so the
       stage container cannot be written in Liquid. Sections opt in with data-stage-slide
       and are collected here; the resulting DOM matches the static preview exactly. */
    if (!el) {
      var marked = $$('[data-stage-slide]');
      if (marked.length < 2) return;
      var first = marked[0];
      var host = first.parentNode;
      while (host && host.parentNode && host.parentNode.nodeName !== 'MAIN' && host.parentNode !== doc.body) host = host.parentNode;
      if (!host || !host.parentNode) return;
      el = doc.createElement('section');
      el.className = 'stage';
      el.setAttribute('data-stage', '');
      var pin = doc.createElement('div');
      pin.className = 'stage__pin';
      el.appendChild(pin);
      host.parentNode.insertBefore(el, host);
      for (var m = 0; m < marked.length; m++) {
        var sec = marked[m];
        var wrapper = sec.parentNode;
        /* move the whole shopify-section wrapper so section settings keep working */
        var node = (wrapper && wrapper.id && wrapper.id.indexOf('shopify-section') === 0) ? wrapper : sec;
        sec.setAttribute('data-slide', String(m));
        sec.className += ' stage__slide';
        pin.appendChild(node);
      }
      var dotsWrap = doc.createElement('div');
      dotsWrap.className = 'stage__dots';
      dotsWrap.setAttribute('role', 'group');
      dotsWrap.setAttribute('aria-label', 'Choose a slide');
      for (var q = 0; q < marked.length; q++) {
        var dot = doc.createElement('button');
        dot.type = 'button';
        dot.className = 'stage__dot';
        dot.setAttribute('data-stage-dot', '');
        dot.setAttribute('aria-current', q === 0 ? 'true' : 'false');
        dot.setAttribute('aria-label', 'Go to slide ' + (q + 1));
        dotsWrap.appendChild(dot);
      }
      pin.appendChild(dotsWrap);
      var hintEl = doc.createElement('div');
      hintEl.className = 'stage__hint';
      hintEl.setAttribute('data-stage-hint', '');
      hintEl.appendChild(doc.createTextNode('Scroll'));
      dotsWrap.insertBefore(hintEl, dotsWrap.firstChild);   /* one pill: the word, then the dots */
    }

    var slides = $$('[data-slide]', el);
    if (slides.length < 2) return;

    var supportsSticky = false;
    try {
      var probe = doc.createElement('div');
      probe.style.position = 'sticky';
      supportsSticky = probe.style.position.indexOf('sticky') > -1;
    } catch (e) { supportsSticky = false; }

    var dots = $$('[data-stage-dot]', el);
    var dotsWrap = $('.stage__dots', el);
    var hint = $('[data-stage-hint]', el);
    var live = null;
    /* the indicators are fixed to the viewport; they show only while the stage owns the screen */
    function setLive(on) {
      if (on === live) return;
      live = on;
      var els = [dotsWrap, hint];
      for (var k = 0; k < els.length; k++) {
        if (!els[k]) continue;
        var c = els[k].className.replace(' is-live', '');
        els[k].className = on ? c + ' is-live' : c;
      }
    }
    var pinned = false, current = -1, ticking = false;

    function canPin() {
      return supportsSticky
        && window.innerWidth >= 900
        && window.innerHeight >= 560
        && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function setCurrent(i) {
      if (i === current) return;
      current = i;
      for (var s = 0; s < slides.length; s++) {
        var cls = slides[s].className.replace(/\s*is-(current|past)/g, '');
        if (s === i) cls += ' is-current';
        else if (s < i) cls += ' is-past';
        slides[s].className = cls;
      }
      for (var d = 0; d < dots.length; d++) {
        dots[d].setAttribute('aria-current', d === i ? 'true' : 'false');
      }
      if (hint) hint.className = 'stage__hint' + (i > 0 ? ' is-done' : '');
    }

    function enable() {
      if (pinned) return;
      pinned = true;
      el.className += ' is-pinned';
      /* one viewport of scroll per slide, plus one to read the last one */
      el.style.height = ((slides.length + 1) * 100) + 'vh';
      current = -1;
      setCurrent(0);
    }
    function disable() {
      setLive(false);
      if (!pinned) return;
      pinned = false;
      el.className = el.className.replace(' is-pinned', '');
      el.style.height = '';
      clearMotion();
      for (var s = 0; s < slides.length; s++) {
        slides[s].className = slides[s].className.replace(/\s*is-(current|past)/g, '');
        slides[s].removeAttribute('aria-hidden');
      }
      for (var d = 0; d < dots.length; d++) dots[d].setAttribute('aria-current', 'false');
      current = -1;
    }

    /* Scroll-linked, not state-switched. Every slide's opacity and offset are a
       continuous function of scroll position, so the sequence flows under the
       finger instead of jumping when a threshold is crossed. */
    var moves = [], depths = [];
    for (var mi = 0; mi < slides.length; mi++) {
      moves.push($('.stage__move', slides[mi]));
      depths.push($$('[data-stage-depth]', slides[mi]));
    }

    function clearMotion() {
      for (var s = 0; s < slides.length; s++) {
        slides[s].style.opacity = '';
        slides[s].style.visibility = '';
        slides[s].removeAttribute('aria-hidden');
        slides[s].style.zIndex = '';
        slides[s].style.pointerEvents = '';
        if (moves[s]) moves[s].style.transform = '';
        for (var d = 0; d < depths[s].length; d++) depths[s][d].style.transform = '';
      }
    }

    function frame() {
      ticking = false;
      if (!pinned) return;
      var travel = el.offsetHeight - window.innerHeight;
      if (travel <= 0) return;
      var r = el.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, -r.top / travel));
      setLive(r.top < window.innerHeight * 0.5 && r.bottom > window.innerHeight);

      /* one unit of pos == one viewport of scroll. The half-slide offset holds the
         first and last slide steady at the ends instead of fading them immediately. */
      var pos = p * slides.length - 0.5;
      if (pos < 0) pos = 0;
      if (pos > slides.length - 1) pos = slides.length - 1;

      for (var s = 0; s < slides.length; s++) {
        var t = pos - s;                 /* <0 still ahead, 0 present, >0 already passed */
        var at = t < 0 ? -t : t;
        var sl = slides[s];

        if (at >= 1) {
          if (sl.style.visibility !== 'hidden') {
            sl.style.visibility = 'hidden';
            sl.style.opacity = '0';
            sl.style.pointerEvents = 'none';
            sl.setAttribute('aria-hidden', 'true');   /* hidden from AT only once it is unfocusable */
          }
          continue;
        }

        var x = at / 0.72;
        if (x > 1) x = 1;
        var o = 1 - x * x * (3 - 2 * x);   /* smoothstep: still position-driven, just eased at the ends */
        sl.style.visibility = 'visible';
        if (sl.getAttribute('aria-hidden') !== 'false') sl.setAttribute('aria-hidden', 'false');
        sl.style.opacity = o.toFixed(3);
        sl.style.zIndex = String(10 - Math.round(at * 9));
        sl.style.pointerEvents = o > 0.5 ? 'auto' : 'none';

        if (moves[s]) {
          moves[s].style.transform =
            'translate3d(0,' + (-t * 7).toFixed(2) + 'vh,0) scale(' + (1 - at * 0.045).toFixed(4) + ')';
        }
        var dl = depths[s];
        for (var d = 0; d < dl.length; d++) {
          var k = parseFloat(dl[d].getAttribute('data-stage-depth')) || 0;
          dl[d].style.transform = 'translate3d(0,' + (-t * k).toFixed(2) + 'vh,0)';
        }

      }
      setCurrent(Math.max(0, Math.min(slides.length - 1, Math.round(pos))));
    }
    function onScroll() { if (!ticking) { ticking = true; (window.requestAnimationFrame || setTimeout)(frame); } }

    function sync() { if (canPin()) { enable(); frame(); } else { disable(); } }

    /* Inside the pinned stage every slide sits at the same place, so an anchor such as
       #liquid cannot be reached by the browser's own jump. Send it to that slide's slice
       of the stage's scroll range instead. */
    function scrollToSlide(i, smooth) {
      if (!pinned) { slides[i].scrollIntoView({ block: 'start' }); return; }
      var travel = el.offsetHeight - window.innerHeight;
      var top = el.offsetTop + (travel * (i + 0.35) / slides.length);
      if (smooth && wantsSmooth() && 'scrollBehavior' in doc.documentElement.style) window.scrollTo({ top: top, behavior: 'smooth' });
      else window.scrollTo(0, top);
    }
    function wantsSmooth() {
      return !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }
    function slideIndexForId(id) {
      for (var i = 0; i < slides.length; i++) if (slides[i].id === id) return i;
      return -1;
    }
    on(doc, 'click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href*="#"]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var hash = href.slice(href.indexOf('#') + 1);
      if (!hash) return;
      var i = slideIndexForId(hash);
      if (i < 0) return;
      e.preventDefault();
      scrollToSlide(i, true);
      if (history.replaceState) history.replaceState(null, '', '#' + hash);
    });
    /* a deep link that arrives with the hash already set: wait for images to settle so
       the stage has its final height, then land on the right slide */
    if (window.location.hash) {
      var deep = slideIndexForId(window.location.hash.slice(1));
      if (deep > -1) {
        var land = function () { window.setTimeout(function () { sync(); scrollToSlide(deep, false); frame(); }, 220); };
        if (doc.readyState === 'complete') land();
        else on(window, 'load', land);
      }
    }

    /* the address bar or a back/forward step can change the hash without a reload */
    on(window, 'hashchange', function () {
      var i = slideIndexForId(window.location.hash.slice(1));
      if (i > -1) scrollToSlide(i, true);
    });

    on(window, 'scroll', onScroll);
    on(window, 'resize', sync);
    /* jumping to a dot scrolls to that slide's slice of the stage */
    for (var d = 0; d < dots.length; d++) {
      (function (i) {
        on(dots[i], 'click', function () { scrollToSlide(i, true); });
      })(d);
    }
    sync();
  }
  buildStage();
  /* the Shopify theme editor re-renders sections; rebuild the stage when it does */
  on(doc, 'shopify:section:load', function () { window.setTimeout(buildStage, 60); });


  /* ================= Interaction layer =================
     Every effect below asks first whether the visitor has a real pointer and wants
     motion. Phones, touch laptops and reduced-motion visitors skip all of it. */
  var finePointer = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  var wantsMotion = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var rich = finePointer && wantsMotion;

  /* ---------- Split the manifesto into words that rise in sequence ---------- */
  (function revealWords() {
    var els = $$('[data-reveal-words]');
    if (!els.length) return;
    els.forEach(function (el) {
      var html = el.innerHTML;
      /* keep inline <em> intact: split only the text between tags */
      var out = html.replace(/>([^<]+)</g, function (m, text) {
        var words = text.split(/(\s+)/).map(function (w) {
          return /\S/.test(w) ? '<span class="word">' + w + '</span>' : w;
        }).join('');
        return '>' + words + '<';
      });
      el.innerHTML = out;
      el.className += ' reveal-words';
      var words = $$('.word', el);
      for (var i = 0; i < words.length; i++) {
        words[i].style.transitionDelay = Math.min(i * 26, 900) + 'ms';
      }
    });
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.className += ' is-in'; }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.className += ' is-in'; io.unobserve(en.target); }
      });
    }, { threshold: 0.25 });
    els.forEach(function (el) { io.observe(el); });
  })();


  /* ---------- Props drift toward the pointer, product rows tilt in 3D ---------- */
  (function pointerDepth() {
    if (!rich) return;
    var scenes = $$('[data-depth-scene]');
    if (!scenes.length) return;
    scenes.forEach(function (scene) {
      var props = $$('.prop', scene);
      var raf = null, mx = 0, my = 0;
      function apply() {
        raf = null;
        for (var i = 0; i < props.length; i++) {
          var sp = parseFloat(props[i].getAttribute('data-depth')) || ((i % 3) + 1) * 5;
          props[i].style.marginLeft = (mx * sp).toFixed(1) + 'px';
          props[i].style.marginTop = (my * sp * 0.6).toFixed(1) + 'px';
        }
      }
      on(scene, 'mousemove', function (e) {
        var r = scene.getBoundingClientRect();
        mx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
        my = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
        if (!raf) raf = (window.requestAnimationFrame || setTimeout)(apply);
      });
      on(scene, 'mouseleave', function () {
        mx = my = 0;
        if (!raf) raf = (window.requestAnimationFrame || setTimeout)(apply);
      });
    });
  })();


  /* ---------- The marquee speeds up and flips with the scroll ---------- */

  /* ---------- Formula timeline: swipe, arrow keys already work, and colour follows ---------- */
  (function timelineSwipe() {
    var tl = $('[data-timeline]');
    if (!tl) return;
    var track = $('.tl__track', tl);
    if (!track) return;
    var startX = null;
    on(track, 'touchstart', function (e) { startX = e.touches[0].clientX; });
    on(track, 'touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) < 46) return;
      var stops = $$('[data-stop]', tl);
      var cur = 0;
      for (var i = 0; i < stops.length; i++) if (stops[i].getAttribute('aria-selected') === 'true') cur = i;
      var next = Math.max(0, Math.min(stops.length - 1, cur + (dx < 0 ? 1 : -1)));
      if (next !== cur) stops[next].click();
    });
  })();

  /* ---------- Scroll spy: the header says where you are ----------
     A long one-pager with a pinned section in the middle gives no sense of place
     otherwise. The pinned slides share one scroll range, so their current index comes
     from the value frame() already computes rather than from a second observer. */
  (function scrollSpy() {
    var links = $$('.nav a, .mobile-nav__links a');
    if (!links.length) return;
    var targets = [];
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      var hash = href.indexOf('#') > -1 ? href.slice(href.indexOf('#') + 1) : '';
      var el = hash && doc.getElementById(hash);
      if (el) targets.push({ id: hash, el: el, links: [] });
    }
    /* several links can point at the same section; group them */
    var byId = {};
    for (var t = 0; t < targets.length; t++) byId[targets[t].id] = targets[t];
    for (var l = 0; l < links.length; l++) {
      var h = links[l].getAttribute('href') || '';
      var k = h.indexOf('#') > -1 ? h.slice(h.indexOf('#') + 1) : '';
      if (byId[k]) byId[k].links.push(links[l]);
    }
    var uniq = [];
    for (var key in byId) if (byId.hasOwnProperty(key)) uniq.push(byId[key]);
    if (!uniq.length) return;

    var currentId = null, ticking = false;
    function mark(id) {
      if (id === currentId) return;
      currentId = id;
      for (var u = 0; u < uniq.length; u++) {
        var on_ = uniq[u].id === id;
        for (var n = 0; n < uniq[u].links.length; n++) {
          if (on_) uniq[u].links[n].setAttribute('aria-current', 'true');
          else uniq[u].links[n].removeAttribute('aria-current');
        }
      }
    }
    function frameSpy() {
      ticking = false;
      var line = window.innerHeight * 0.34;   /* the reading line, not the very top */
      var best = null, bestTop = -Infinity;
      for (var u = 0; u < uniq.length; u++) {
        var el = uniq[u].el;
        /* a pinned slide reports the stage's box, so ask whether it is the visible one */
        if (el.getAttribute('data-slide') !== null && el.style.visibility === 'hidden') continue;
        var top = el.getBoundingClientRect().top;
        if (top <= line && top > bestTop) { bestTop = top; best = uniq[u].id; }
      }
      mark(best);
    }
    on(window, 'scroll', function () { if (!ticking) { ticking = true; (window.requestAnimationFrame || setTimeout)(frameSpy); } });
    on(window, 'resize', frameSpy);
    frameSpy();
  })();

  /* ---------- The opening: form toggle and film ----------
     One control moves three things — the headline's product wording, the six bottles on
     show, and the film behind them — so choosing a form is something you can see rather
     than a label you have to read. The <video> ships with no sources; they are attached
     only on a wide viewport, with motion welcome and data saving off, so a phone spends
     nothing on it. */
  (function opener() {
    var section = $('.opener');
    if (!section) return;
    var vid = $('[data-hero-video]');
    var wrap = $('[data-hero-video-wrap]');
    var picks = $$('[data-pick-form]');
    var shots = $$('[data-form-media]');
    var cta = $('[data-form-cta]');
    var mq = window.matchMedia;
    var wantsMove = !(mq && mq('(prefers-reduced-motion: reduce)').matches);
    var conn = navigator.connection || {};
    var saveData = !!conn.saveData;
    var slow = /(^|-)2g$/.test(conn.effectiveType || '');   /* a phone on 2G is spared the film */
    var filmOk = !!mq && wantsMove && !saveData && !slow && vid && wrap;
    var current = null;
    var ctl = $('[data-film-toggle]');
    var held = false;                     /* the visitor pressed pause */
    function setCtl() {
      if (!ctl) return;
      ctl.hidden = false;
      ctl.setAttribute('aria-pressed', held ? 'true' : 'false');
      ctl.textContent = held ? 'Play film' : 'Pause film';
    }

    function show() {
      if (!wrap) return;
      wrap.className = wrap.className.replace(' is-switching', '');
      if (wrap.className.indexOf('is-playing') < 0) wrap.className += ' is-playing';
    }
    var pendingFilm = 0;
    function loadFilm(form) {
      if (!filmOk) return;
      var webm = vid.getAttribute('data-webm-' + form);
      var mp4 = vid.getAttribute('data-mp4-' + form);
      if (!webm && !mp4) return;
      function go() {
        while (vid.firstChild) vid.removeChild(vid.firstChild);
        if (webm) { var a = doc.createElement('source'); a.type = 'video/webm'; a.src = webm; vid.appendChild(a); }
        if (mp4)  { var b = doc.createElement('source'); b.type = 'video/mp4';  b.src = mp4;  vid.appendChild(b); }
        vid.load();
        if (held) { show(); return; }
        var p = vid.play();
        if (p && p.catch) p.catch(function () { show(); });
      }
      /* a film already showing dissolves out first; the new one fades in when it plays */
      if (wrap.className.indexOf('is-playing') > -1) {
        if (wrap.className.indexOf('is-switching') < 0) wrap.className += ' is-switching';
        window.clearTimeout(pendingFilm);
        pendingFilm = window.setTimeout(go, 460);
      } else {
        go();
      }
    }

    function set(form) {
      if (form === current) return;
      current = form;
      section.setAttribute('data-form', form);
      for (var i = 0; i < picks.length; i++) {
        picks[i].setAttribute('aria-pressed', picks[i].getAttribute('data-pick-form') === form ? 'true' : 'false');
      }
      for (var s2 = 0; s2 < shots.length; s2++) {
        var off = shots[s2].getAttribute('data-form-media') !== form;
        shots[s2].hidden = false;                 /* the markup hides the second one for no-JS */
        shots[s2].className = shots[s2].className.replace(' is-off', '') + (off ? ' is-off' : '');
        shots[s2].setAttribute('aria-hidden', off ? 'true' : 'false');
      }
      if (cta) cta.setAttribute('href', '#' + form);
      loadFilm(form);
    }

    picks.forEach(function (b) {
      on(b, 'click', function () { set(b.getAttribute('data-pick-form')); });
    });

    if (vid) { on(vid, 'playing', show); on(vid, 'loadeddata', show); }
    if (vid && ctl && filmOk) {
      on(vid, 'playing', setCtl);
      on(ctl, 'click', function () {
        held = !held;
        if (held) vid.pause(); else { var r = vid.play(); if (r && r.catch) r.catch(function () {}); }
        setCtl();
      });
    }
    set(section.getAttribute('data-form') || 'capsules');

    /* stop the decoder while the opening is off screen */
    if (filmOk && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { if (!held) { var q = vid.play(); if (q && q.catch) q.catch(function () {}); } }
        else { vid.pause(); }
      }, { rootMargin: '100px 0px' });
      io.observe(wrap);
    }
  })();

  /* ---------- The botanical explorer ----------
     One entry open at a time, per formula. The bodies are already in the DOM, so this
     only toggles which is shown; with JavaScript off the first entry of each formula
     stays open and the rest are simply further down the page. */
  (function herbs() {
    var groups = $$('[data-herbs]');
    if (!groups.length) return;
    groups.forEach(function (group) {
      var btns = $$('[data-herb]', group);
      function open(btn) {
        for (var i = 0; i < btns.length; i++) {
          var on = btns[i] === btn;
          btns[i].setAttribute('aria-expanded', on ? 'true' : 'false');
          var body = btns[i].parentNode.querySelector('[data-herb-body]');
          if (body) body.hidden = !on;
        }
      }
      /* left and right walk the set, home and end jump to the ends */
      on(group, 'keydown', function (e) {
        var i = btns.indexOf(doc.activeElement);
        if (i < 0) return;
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = btns[(i + 1) % btns.length];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = btns[(i - 1 + btns.length) % btns.length];
        else if (e.key === 'Home') next = btns[0];
        else if (e.key === 'End') next = btns[btns.length - 1];
        if (next) { e.preventDefault(); next.focus(); open(next); }
      });
      btns.forEach(function (b) {
        on(b, 'click', function () { open(b); });
        /* on a pointer device, reading is faster than clicking */
        on(b, 'mouseenter', function () {
          if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) open(b);
        });
        on(b, 'focus', function () { open(b); });
      });
    });
  })();

  /* ---------- Footer year ---------- */
  $$('[data-year]').forEach(function (el) { el.textContent = String(new Date().getFullYear()); });

  window.FBD = { cart: Cart, toast: toast };
})();
